import classNames from 'classnames'
import { TrustpilotStars } from 'components/common/TrustpilotStars'
import routes from 'constants/routes'
import useTranslation from 'next-translate/useTranslation'
import { PropsWithClassName } from 'types'

const sizeVariants = {
  authForm: {
    root: 'space-x-2.5 p-2',
    text: 'text-sm',
    icon: 'w-[1.125rem] h-[1.125rem]',
    iconSize: 13,
  },
  lg: {
    root: 'space-x-5',
    text: 'text-base',
    icon: 'w-6 h-6',
    iconSize: 18,
  },
  md: {
    root: 'space-x-5',
    text: 'text-sm',
    icon: 'w-6 h-6',
    iconSize: 18,
  },
  sm: {
    root: 'space-x-3',
    text: 'text-xs',
    icon: 'w-5 h-5',
    iconSize: 15,
  },
} as const

const colorVariants = {
  lightGreen: {
    root: 'bg-[#E6F5F1]',
    text: '',
  },
  darkGreen: {
    root: 'bg-success-default',
    text: 'text-cool-50',
  },
} as const

interface Props extends PropsWithClassName {
  size: keyof typeof sizeVariants
  color?: keyof typeof colorVariants
}

export function ReviewBanner({
  size = 'md',
  color = 'lightGreen',
  className,
}: Props) {
  const { t } = useTranslation('common')
  const sizeVariant = sizeVariants[size]
  const colorVariant = colorVariants[color]

  return (
    <a
      href={routes.trustpilot}
      target='_blank'
      rel='noopener noreferrer'
      className={classNames(
        'flex items-center gap-y-1 rounded',
        sizeVariant.root,
        colorVariant.root,
        className
      )}
    >
      <p
        className={classNames(
          'whitespace-nowrap font-body tracking-normal',
          colorVariant.text,
          sizeVariant.text
        )}
      >
        {t('review_banner_text')}
      </p>

      <TrustpilotStars
        itemClass={sizeVariant.icon}
        iconSize={sizeVariant.iconSize}
        iconColor={color}
      />
    </a>
  )
}
